import { render, staticRenderFns } from "./UsedMaterials.vue?vue&type=template&id=140f9fd8"
import script from "./UsedMaterials.vue?vue&type=script&lang=js"
export * from "./UsedMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports